var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSignUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1250 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M251 245c0 42 11 80 34 115 24 35 55 61 93 77 39 16 79 20 120 12 41-9 76-29 105-59 30-30 49-65 57-106s4-81-12-119c-16-39-41-70-76-93s-74-34-116-34c-37 0-71 9-103 28-31 19-56 45-75 77-18 31-27 65-27 102zm213 313c-83 0-158 14-224 42-69 28-124 70-165 125C31 783 6 853 0 934c2 10 6 19 12 27 7 7 16 12 26 15h853c12 1 22-3 30-11 8-9 11-19 9-31-5-83-29-154-72-212-41-54-96-95-166-123-67-27-143-41-228-41zm517-103c-14 0-26-5-36-15-10-11-15-24-15-38V297H827c-14 0-27-5-38-15-10-11-15-23-15-37s5-26 15-36c11-10 24-15 38-15h103V89c-3-11-2-22 2-32s10-18 19-24 19-9 30-9 21 3 30 9 16 14 20 24 4 21 1 32v105h104c14 0 26 5 36 15 11 10 16 22 16 36s-5 26-16 37c-10 10-22 15-36 15h-104v105c0 14-5 27-15 38-10 10-22 15-36 15z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSignUp);
export default __webpack_public_path__ + "static/media/ic_sign-up.fde06b992ffa8e862c6f61654206c702.svg";
export { ForwardRef as ReactComponent };